import { TFunction } from 'i18next';
import { User } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import getDepartmentMembersTableActionsMenu from 'routes/Departments/utils/getDepartmentMembersTableActionsMenu';

type ActionsMenuArgs = {
  currentUserId?: string;
  onActivate: (item?: User) => void;
  onDeactivate: (item?: User) => void;
  onEdit: (item?: User) => void;
  onEditAccesses: (item?: User) => void;
  onRemoveMember: (item?: User) => void;
  onView?: (item?: User) => void;
  t: TFunction<'translation', undefined>;
  isViewOnly: boolean;
};

export default function getTeamMembersTableActionsMenu({
  currentUserId,
  onActivate,
  onDeactivate,
  onEdit,
  onEditAccesses,
  onRemoveMember,
  onView,
  t,
  isViewOnly,
}: ActionsMenuArgs): NavItem<User>[] {
  return [
    ...getDepartmentMembersTableActionsMenu({
      currentUserId,
      onActivate,
      onDeactivate,
      onEdit,
      onEditAccesses,
      onView,
      t,
      isViewOnly,
    }),
    {
      id: 'remove-member-action',
      title: t('remove-member'),
      onClick: onRemoveMember,
      leftIcon: Icons.personRemove,
      type: NavItemTypeEnum.Secondary,
      predictorFnDisable: (item?: User) => currentUserId === item?.id,
      predictorFnVisible: () => !isViewOnly,
    },
  ];
}
